var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pt-0 mt-0"},[_vm._l((_vm.etags),function(etag){return [_c('EtagListItem',{key:etag.tagID,staticClass:"pl-6 pr-6",attrs:{"etag":etag},on:{"selected":_vm.selected}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }